/**
 * Created by piotr.pozniak@thebeaverhead.com on 02/09/2024
 */

import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

/**
 * @param {Object} props
 * @param {String} [props.className=""] - additional class name for the icon
 */
const PrivateEventBadge = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <i
      className={classNames("material-icons private-event", className)}
      role="img"
      aria-label={t("Private event")}
      title="This is a private event, that comes from private calendar. This icon is only to indicate this information and it is not visible on your website."
    >
      lock
    </i>
  );
};

export default PrivateEventBadge;
